export const calcTotalBannersPaddingTop = () => {
  const headerElementWrapper = document.querySelector('#exp-hdr')
  const headerElement = document.querySelector('#pcln-global-header')

  if (
    headerElementWrapper &&
    headerElement &&
    window.getComputedStyle(headerElement, null).position === 'fixed'
  ) {
    const mainContentElement = headerElementWrapper.nextElementSibling
    if (mainContentElement && window.matchMedia('(min-width: 601px)').matches) {
      const headerElHeightString = window.getComputedStyle(headerElement, null)
        .height

      const headerElHeightNum = parseInt(headerElHeightString) - 60

      mainContentElement.style.paddingTop = headerElHeightNum + 'px'
    }
  }
}
